import { GET_EMPLOYEE_SUMMARY } from "./types";
import { EmployeeSummaryType } from "@type/HRM/employee-summary";

export const getEmployeeSummaryRequest = () => {
  return {
    type: GET_EMPLOYEE_SUMMARY.GET_EMPLOYEE_SUMMARY_REQUEST,
  } as const;
};

export const getEmployeeSummarySuccess = (data: EmployeeSummaryType[]) => {
  return {
    type: GET_EMPLOYEE_SUMMARY.GET_EMPLOYEE_SUMMARY_SUCCESS,
    payload: { data },
  } as const;
};

export const getEmployeeSummaryFailed = () => {
  return {
    type: GET_EMPLOYEE_SUMMARY.GET_EMPLOYEE_SUMMARY_FAILED,
  } as const;
};

export type EmployeesSummaryActions =
  | ReturnType<typeof getEmployeeSummaryRequest>
  | ReturnType<typeof getEmployeeSummarySuccess>
  | ReturnType<typeof getEmployeeSummaryFailed>;
